import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "plate__left-addons"
}
const _hoisted_2 = { class: "plate__content" }
const _hoisted_3 = { class: "plate__wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "plate__title"
}
const _hoisted_5 = {
  key: 1,
  class: "plate__subtitle"
}
const _hoisted_6 = {
  key: 2,
  class: "plate__text"
}
const _hoisted_7 = {
  key: 0,
  class: "plate__addons-control"
}
const _hoisted_8 = {
  key: 1,
  class: "plate__right-addons"
}

import { PropType, computed, onMounted, ref, useSlots } from "vue";
/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-plate',
  props: {
  /**
   * Скруглен полностью
   */
  variant: {
    type: String as PropType<"default" | "attention" | "negative" | "positive">,
    default: "default",
  },
  /**
   * Скруглен полностью
   */
  positionControlAddons: {
    type: String as PropType<"right" | "bottom">,
    default: "right",
  },
  /**
   * Показывать ли активное состояние
   */
  isShow: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Скруглены ли края
   */
  isRounded: { type: Boolean as PropType<boolean>, default: false },

  /**
   * С границами или нет
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["update:modelValue", "check"],
  setup(__props, { emit }) {

const props = __props;





/**
 * Слоты
 */
const slots = useSlots();
/**
 * Левый аддон
 */
const isLeftAddon = computed(() => slots && slots.leftAddon && slots.leftAddon());
/**
 * Левый аддон
 */
const isRightAddon = computed(() => slots && slots.rightAddon && slots.rightAddon());
/**
 * Заголовок
 */
const isTitleSlot = computed(() => slots && slots.titleSlot && slots.titleSlot());
/**
 * Подзаголовок
 */
const isSubtitleSlot = computed(() => slots && slots.subtitleSlot && slots.subtitleSlot());

/**
 * Текст
 */
const isText = computed(() => slots && slots.text && slots.text());

/**
 * Классы из пропсов
 */

const computedClasses = computed(() => {
  return {
    "plate--show": props.isShow,
    "plate--addons-conntrols-position-right": props.positionControlAddons == "right",
    "plate--addons-conntrols-position-bottom": props.positionControlAddons == "bottom",
    "plate--variant-default": props.variant == "default",
    "plate--variant-attention": props.variant == "attention",
    "plate--variant-negative": props.variant == "negative",
    "plate--variant-positive": props.variant == "positive",
    "plate--rounded": props.isRounded,
    "plate--bordered": props.isBordered,
  };
});
const isControlsAddons = computed(() => slots && slots.controlsAddons && slots.controlsAddons());

const elementHeight = ref<number>();
const plateElement = ref(null);

console.log("errwdadwwadaw", plateElement.value);

onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "plate" }, {
    default: _withCtx(() => [
      (props.isShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["plate", computedClasses.value]),
            ref_key: "plateElement",
            ref: plateElement
          }, [
            (isLeftAddon.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "leftAddon")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (isTitleSlot.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "titleSlot")
                    ]))
                  : _createCommentVNode("", true),
                (isSubtitleSlot.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "subtitleSlot")
                    ]))
                  : _createCommentVNode("", true),
                (isText.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _renderSlot(_ctx.$slots, "text")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (isControlsAddons.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "controlsAddons")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (isRightAddon.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "rightAddon")
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})